export default "__VITE_ASSET__ESIH2p$8__"